export const APP_NAME = {
    TMS: 'TMS',
    ACP: 'ACP',
};
